export default {"src":"/_next/static/media/twitter_icon.521bc59d.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};